import { addIcons, OhVueIcon, type CustomizeIconType } from 'oh-vue-icons';
import {
  BiHandbag,
  BiPrinter,
  GiKnifeFork,
  IoClose,
  MdFoodbankRound,
  MdTablebarOutlined,
  PrBell,
  RiCloseCircleLine,
  RiMenu2Fill,
  RiSettings3Line,
} from 'oh-vue-icons/icons';
import type { App } from 'vue';

export default (app: App) => {
  addIcons(
    RiMenu2Fill,
    PrBell,
    BiHandbag,
    RiCloseCircleLine,
    BiPrinter,
    MdTablebarOutlined,
    MdFoodbankRound,
    GiKnifeFork,
    IoClose,
    RiSettings3Line,
    CustomBag2,
    CustomTable,
    CustomPrinter2,
    CustomClose2,
    CustomNotificationBing2,
    CustomMenu2,
    CustomSetting2,
    CustomTimer2,
    CustomReserve2,
    CustomApple2,
    CustomGoogle2,
    CustomCircleCheck2,
    CustomCircleTopRight2,
    CustomCreditCard2,
    CustomCash2,
    CustomQrCode2,
    CustomEye2,
    CustomEyeSlash2,
    CustomSaucepan2,
    CustomTextLogo2,
    CustomClock2,
    CustomeInfoCircle,
    CustomTickCircle,
  );

  app.component('v-icon', OhVueIcon);
};

const CustomBag2: CustomizeIconType = {
  name: 'custom-bag-2',
  width: 22,
  height: 21,
  raw: `<path fill-rule="evenodd" clip-rule="evenodd" d="M10.2822 2.93823C12.0932 2.76394 13.61 4.17624 13.61 5.92501V6.41667H7.54999V6.08335C7.54999 4.55598 8.8137 3.07421 10.2795 2.93848L10.2795 2.93849L10.2822 2.93823ZM6.04999 6.48108V6.08335C6.04999 3.86115 7.82639 1.66001 10.1399 1.445C12.8308 1.18679 15.11 3.29088 15.11 5.92501V6.46902C16.3316 6.58938 17.2345 6.9259 17.8158 7.56713C18.5809 8.41116 18.5801 9.55454 18.4654 10.5831C18.4195 10.9948 18.0485 11.2913 17.6369 11.2454C17.2252 11.1995 16.9287 10.8285 16.9746 10.4169C17.0867 9.41214 16.9893 8.88885 16.7044 8.57455C16.4079 8.24748 15.6987 7.91667 13.94 7.91667H7.22C5.51304 7.91667 4.74409 8.31498 4.38796 8.73503C4.02686 9.16092 3.91106 9.81594 4.0168 10.77L4.64611 15.7646L4.64778 15.7778L4.64766 15.7778C4.73055 16.5453 4.89968 17.0538 5.28451 17.4026C5.67753 17.7588 6.44729 18.0833 8.06 18.0833H13.1C14.5387 18.0833 15.1544 17.8703 15.4688 17.6209C15.7729 17.3795 15.9393 16.997 16.1527 16.1501C16.254 15.7484 16.6616 15.5049 17.0633 15.6061C17.4649 15.7073 17.7085 16.115 17.6073 16.5166C17.4007 17.3364 17.1471 18.2039 16.4012 18.7958C15.6656 19.3797 14.6013 19.5833 13.1 19.5833H8.06C6.29591 19.5833 5.07486 19.237 4.27718 18.5141C3.47341 17.7856 3.251 16.8098 3.15706 15.9456L2.52788 10.9521L2.52654 10.9415L2.52662 10.9415C2.40655 9.86503 2.47158 8.67582 3.24384 7.76498C3.84889 7.05135 4.78101 6.63213 6.04999 6.48108ZM12.5162 10.5C12.5162 9.94772 12.9639 9.5 13.5162 9.5H13.5237C14.076 9.5 14.5237 9.94772 14.5237 10.5C14.5237 11.0523 14.076 11.5 13.5237 11.5H13.5162C12.9639 11.5 12.5162 11.0523 12.5162 10.5ZM7.63538 9.5C7.0831 9.5 6.63538 9.94772 6.63538 10.5C6.63538 11.0523 7.0831 11.5 7.63538 11.5H7.64293C8.19521 11.5 8.64293 11.0523 8.64293 10.5C8.64293 9.94772 8.19521 9.5 7.64293 9.5H7.63538ZM21.1974 13.3101C21.3289 13.4453 21.41 13.6298 21.41 13.8333C21.41 14.0333 21.3302 14.225 21.1882 14.3658L19.5082 16.0324C19.2142 16.3242 18.7393 16.3223 18.4476 16.0282C18.1558 15.7342 18.1577 15.2593 18.4518 14.9676L18.8391 14.5833H17.3C16.8858 14.5833 16.55 14.2476 16.55 13.8333C16.55 13.4191 16.8858 13.0833 17.3 13.0833H18.8391L18.4518 12.6991C18.1577 12.4074 18.1558 11.9325 18.4476 11.6385C18.7393 11.3444 19.2142 11.3425 19.5082 11.6342L21.1882 13.3009C21.1913 13.304 21.1943 13.307 21.1974 13.3101Z"/>`,
};

const CustomTable: CustomizeIconType = {
  name: 'custom-table-2',
  width: 22,
  height: 19,
  paths: [
    {
      d: `M5.7832 7.04999C5.7832 6.63577 6.11899 6.29999 6.5332 6.29999H11H15.4749C15.8891 6.29999 16.2249 6.63577 16.2249 7.04999C16.2249 7.4642 15.8891 7.79999 15.4749 7.79999H11.75V16.9666H13.015C13.4292 16.9666 13.765 17.3024 13.765 17.7166C13.765 18.1309 13.4292 18.4666 13.015 18.4666H8.97502C8.5608 18.4666 8.22502 18.1309 8.22502 17.7166C8.22502 17.3024 8.5608 16.9666 8.97502 16.9666H10.25V7.79999H6.5332C6.11899 7.79999 5.7832 7.4642 5.7832 7.04999Z`,
    },
    {
      d: `M20.6582 0.658325C21.0033 0.658325 21.2832 0.938147 21.2832 1.28333V11.0179L21.2833 11.0333L21.2832 11.0487V17.7083C21.2832 18.0535 21.0033 18.3333 20.6582 18.3333C20.313 18.3333 20.0332 18.0535 20.0332 17.7083V11.6583H16.0583V17.7166C16.0583 18.0618 15.7785 18.3416 15.4333 18.3416C15.0882 18.3416 14.8083 18.0618 14.8083 17.7166V11.0333C14.8083 10.6881 15.0882 10.4083 15.4333 10.4083H20.0332V1.28333C20.0332 0.938147 20.313 0.658325 20.6582 0.658325Z`,
    },
    {
      d: `M1.3418 0.533325C1.75601 0.533325 2.0918 0.869112 2.0918 1.28333V10.2833H6.56661H6.5668C6.98101 10.2833 7.3168 10.6191 7.3168 11.0333C7.3168 11.039 7.31673 11.0446 7.31661 11.0502V17.7166C7.31661 18.1309 6.98082 18.4666 6.56661 18.4666C6.1524 18.4666 5.81661 18.1309 5.81661 17.7166V11.7833H2.0918V17.7167C2.0918 18.1309 1.75601 18.4667 1.3418 18.4667C0.927583 18.4667 0.591797 18.1309 0.591797 17.7167V11.0333V1.28333C0.591797 0.869112 0.927583 0.533325 1.3418 0.533325Z`,
    },
  ],
};

const CustomPrinter2: CustomizeIconType = {
  name: 'custom-printer-2',
  width: 24,
  height: 24,
  raw: `<path fill-rule="evenodd" clip-rule="evenodd" d="M7.3591 2.23704C8.03327 1.51793 9.03399 1.25 10.25 1.25H13.75C14.966 1.25 15.9667 1.51793 16.6409 2.23704C17.3054 2.94586 17.5 3.93363 17.5 5V6.25H18C19.1156 6.25 20.0901 6.52941 20.7803 7.21967C21.4706 7.90993 21.75 8.88439 21.75 10V15C21.75 16.1156 21.4706 17.0901 20.7803 17.7803C20.0901 18.4706 19.1156 18.75 18 18.75H16.75V19C16.75 20.1156 16.4706 21.0901 15.7803 21.7803C15.0901 22.4706 14.1156 22.75 13 22.75H11C9.88439 22.75 8.90993 22.4706 8.21967 21.7803C7.52941 21.0901 7.25 20.1156 7.25 19V18.75H6C4.88439 18.75 3.90993 18.4706 3.21967 17.7803C2.52941 17.0901 2.25 16.1156 2.25 15V10C2.25 8.88439 2.52941 7.90993 3.21967 7.21967C3.90993 6.52941 4.88439 6.25 6 6.25H6.5V5C6.5 3.93363 6.69458 2.94586 7.3591 2.23704ZM8 6.25H16V5C16 4.06637 15.8196 3.55414 15.5466 3.26296C15.2833 2.98207 14.784 2.75 13.75 2.75H10.25C9.21601 2.75 8.71673 2.98207 8.4534 3.26296C8.18042 3.55414 8 4.06637 8 5V6.25ZM7.25 17.25V15.75H7C6.58579 15.75 6.25 15.4142 6.25 15C6.25 14.5858 6.58579 14.25 7 14.25H8H15.79H16H17C17.4142 14.25 17.75 14.5858 17.75 15C17.75 15.4142 17.4142 15.75 17 15.75H16.75V17.25H18C18.8844 17.25 19.4099 17.0294 19.7197 16.7197C20.0294 16.4099 20.25 15.8844 20.25 15V10C20.25 9.11561 20.0294 8.59007 19.7197 8.28033C19.4099 7.97059 18.8844 7.75 18 7.75H16.75H7.25H6C5.11561 7.75 4.59007 7.97059 4.28033 8.28033C3.97059 8.59007 3.75 9.11561 3.75 10V15C3.75 15.8844 3.97059 16.4099 4.28033 16.7197C4.59007 17.0294 5.11561 17.25 6 17.25H7.25ZM8.75 18V15.75H15.25V18V19C15.25 19.8844 15.0294 20.4099 14.7197 20.7197C14.4099 21.0294 13.8844 21.25 13 21.25H11C10.1156 21.25 9.59007 21.0294 9.28033 20.7197C8.97059 20.4099 8.75 19.8844 8.75 19V18ZM7 10.25C6.58579 10.25 6.25 10.5858 6.25 11C6.25 11.4142 6.58579 11.75 7 11.75H10C10.4142 11.75 10.75 11.4142 10.75 11C10.75 10.5858 10.4142 10.25 10 10.25H7Z" fill="#707070" fill-opacity="0.8"/>`,
};

const CustomClose2: CustomizeIconType = {
  name: 'custom-close-2',
  width: 24,
  height: 24,
  attr: { fill: 'none' },
  paths: [
    {
      d: 'M9.17163 14.8284L14.8285 9.17158',
    },
    {
      d: 'M14.8285 14.8284L9.17163 9.17157',
    },
    {
      d: 'M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z',
    },
  ].map((d) => ({
    stroke: 'currentColor',
    'stroke-opacity': '0.8',
    'stroke-width': '1.5',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    ...d,
  })),
};

const CustomNotificationBing2: CustomizeIconType = {
  name: 'custom-notification-bing',
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 6.44V9.77',
    },
    {
      d: 'M12.0199 2C8.3399 2 5.3599 4.98 5.3599 8.66V10.76C5.3599 11.44 5.0799 12.46 4.7299 13.04L3.4599 15.16C2.6799 16.47 3.2199 17.93 4.6599 18.41C9.4399 20 14.6099 20 19.3899 18.41C20.7399 17.96 21.3199 16.38 20.5899 15.16L19.3199 13.04C18.9699 12.46 18.6899 11.43 18.6899 10.76V8.66C18.6799 5 15.6799 2 12.0199 2Z',
    },
    {
      d: 'M15.3299 18.82C15.3299 20.65 13.8299 22.15 11.9999 22.15C11.0899 22.15 10.2499 21.77 9.64992 21.17C9.04992 20.57 8.66992 19.73 8.66992 18.82',
    },
  ].map((d) => ({
    stroke: 'currentColor',
    'stroke-width': '1.5',
    'stroke-miterlimit': '10',
    'stroke-linecap': 'round',
    ...d,
  })),
};

const CustomMenu2: CustomizeIconType = {
  name: 'custom-menu-2',
  width: 24,
  height: 24,
  paths: [{ d: 'M3 7H21' }, { d: 'M3 12H13' }, { d: 'M3 17H18' }].map((d) => ({
    stroke: 'currentColor',
    'stroke-width': '1.5',
    'stroke-linecap': 'round',
    ...d,
  })),
};

const CustomSetting2: CustomizeIconType = {
  name: 'custom-setting-2',
  width: 24,
  height: 24,
  paths: [
    { d: 'M22 6.5H16' },
    { d: 'M6 6.5H2' },
    {
      d: 'M10 10C11.933 10 13.5 8.433 13.5 6.5C13.5 4.567 11.933 3 10 3C8.067 3 6.5 4.567 6.5 6.5C6.5 8.433 8.067 10 10 10Z',
    },
    { d: 'M22 17.5H18' },
    { d: 'M8 17.5H2' },
    {
      d: 'M14 21C15.933 21 17.5 19.433 17.5 17.5C17.5 15.567 15.933 14 14 14C12.067 14 10.5 15.567 10.5 17.5C10.5 19.433 12.067 21 14 21Z',
    },
  ].map((d) => ({
    stroke: 'currentColor',
    'stroke-width': '1.5',
    'stroke-miterlimit': '10',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    ...d,
  })),
};

const CustomTimer2: CustomizeIconType = {
  name: 'custom-timer-2',
  width: 18,
  height: 18,
  paths: [
    {
      d: 'M15.5625 9.9375C15.5625 13.56 12.6225 16.5 9 16.5C5.3775 16.5 2.4375 13.56 2.4375 9.9375C2.4375 6.315 5.3775 3.375 9 3.375C12.6225 3.375 15.5625 6.315 15.5625 9.9375Z',
    },
    { d: 'M9 6V9.75' },
    {
      d: 'M6.75 1.5H11.25',
    },
  ].map((d) => ({
    stroke: 'currentColor',
    'stroke-width': '1.5',
    'stroke-miterlimit': '10',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    ...d,
  })),
};

const CustomClock2: CustomizeIconType = {
  name: 'custom-clock-2',
  width: 14,
  height: 14,
  paths: [
    {
      d: 'M12.8337 7.00002C12.8337 10.22 10.2203 12.8334 7.00033 12.8334C3.78033 12.8334 1.16699 10.22 1.16699 7.00002C1.16699 3.78002 3.78033 1.16669 7.00033 1.16669C10.2203 1.16669 12.8337 3.78002 12.8337 7.00002Z',
    },
    {
      d: 'M9.16418 8.85503L7.35585 7.77586C7.04085 7.58919 6.78418 7.14003 6.78418 6.77253V4.38086',
    },
  ].map((d) => ({
    stroke: 'currentColor',
    'stroke-miterlimit': '10',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    ...d,
  })),
};

const CustomReserve2: CustomizeIconType = {
  name: 'custom-reserve-2',
  width: 18,
  height: 18,
  paths: [
    {
      'fill-rule': 'evenodd',
      'clip-rule': 'evenodd',
      d: 'M8.23464 3.22175C8.41181 3.20727 8.59073 3.19962 8.77133 3.19872L8.80744 3.19863L8.80747 3.19863L9.93147 3.19863L9.93151 3.19863C10.126 3.19863 10.3199 3.20644 10.5122 3.22218C10.3662 2.73144 9.91121 2.37305 9.37337 2.37305C8.83568 2.37305 8.38082 2.73123 8.23464 3.22175ZM9.37337 0.873047C10.8478 0.873047 12.0459 2.06165 12.0612 3.53251C14.8599 4.43373 16.883 7.05125 16.883 10.1502V12.6061C17.4496 12.8289 17.852 13.3817 17.852 14.0261V14.8013V14.8254V14.8254C17.8521 15.1277 17.8521 15.4747 17.8094 15.8015C17.7646 16.1439 17.6668 16.5244 17.4287 16.8696C16.9219 17.6045 16.0114 17.8769 14.7764 17.8769H3.92373C2.68874 17.8769 1.77826 17.6045 1.27144 16.8696C1.03335 16.5244 0.935561 16.1439 0.890813 15.8015C0.848084 15.4747 0.848117 15.1278 0.848146 14.8254V14.8254L0.848149 14.8013V14.0261C0.848149 13.3671 1.269 12.8039 1.85589 12.5914V10.1502C1.85589 7.05187 3.88519 4.4271 6.68555 3.531C6.70166 2.06084 7.89941 0.873047 9.37337 0.873047ZM11.0789 4.8203L11.0702 4.81839C10.7109 4.73925 10.3268 4.69863 9.93151 4.69863L9.93147 4.69863L8.80747 4.69863H8.80744C8.65837 4.69863 8.51186 4.70441 8.36782 4.71588C8.12773 4.735 7.89451 4.76993 7.66785 4.8203L7.6646 4.82102L7.66158 4.82169L7.66157 4.82167L7.65842 4.82234C5.20048 5.34814 3.35589 7.53578 3.35589 10.1502V12.501H15.383V10.1502C15.383 7.53478 13.5444 5.35305 11.0832 4.82125L11.0789 4.8203L11.0789 4.8203ZM2.60589 14.001H2.37334C2.36987 14.001 2.3677 14.0015 2.36561 14.0024C2.363 14.0035 2.35957 14.0056 2.35619 14.009C2.35281 14.0124 2.35072 14.0158 2.34961 14.0184C2.34872 14.0205 2.34815 14.0227 2.34815 14.0261V14.8013C2.34815 15.133 2.34935 15.3867 2.37816 15.6071C2.40609 15.8207 2.45364 15.9417 2.50626 16.018C2.58083 16.1261 2.83314 16.3769 3.92373 16.3769H14.7764C15.867 16.3769 16.1193 16.1261 16.1939 16.018C16.2465 15.9417 16.2941 15.8207 16.322 15.6071C16.3508 15.3867 16.352 15.133 16.352 14.8013V14.0261C16.352 14.0227 16.3515 14.0205 16.3506 14.0184L16.3498 14.0168L16.3486 14.0147C16.3474 14.0129 16.3459 14.0109 16.344 14.009C16.3406 14.0056 16.3372 14.0035 16.3346 14.0024C16.3325 14.0015 16.3303 14.001 16.3268 14.001H16.133H2.60589ZM7.04778 7.84979C6.63357 7.84979 6.29778 8.18558 6.29778 8.59979C6.29778 9.014 6.63357 9.34979 7.04778 9.34979H11.6989C12.1132 9.34979 12.4489 9.014 12.4489 8.59979C12.4489 8.18558 12.1132 7.84979 11.6989 7.84979H7.04778Z',
    },
  ],
};

const CustomApple2: CustomizeIconType = {
  name: 'custom-apple-2',
  width: 21,
  height: 20,
  paths: [
    {
      d: `M12.8663 1.66669C13.033 2.58335 12.6163 3.50002 12.1163 4.16669C11.6163 4.83335 10.6997 5.41669 9.783 5.33335C9.61633 4.41669 10.033 3.58335 10.533 2.91669C11.1163 2.25002 12.033 1.75002 12.8663 1.66669ZM15.533 16.1667C15.9497 15.5 16.1997 15.0834 16.533 14.3334C13.9497 13.3334 13.533 9.66669 16.1163 8.33335C15.3663 7.33335 14.283 6.83335 13.1997 6.83335C12.4497 6.83335 11.9497 7.00002 11.4497 7.16669C11.033 7.33335 10.6997 7.41669 10.283 7.41669C9.783 7.41669 9.44966 7.25002 8.94966 7.08335C8.44966 6.91669 7.94966 6.75002 7.36633 6.75002C6.19966 6.75002 4.94966 7.41669 4.19966 8.66669C3.11633 10.3334 3.283 13.5834 5.033 16.25C5.783 17.25 6.61633 18.3334 7.69966 18.3334C8.19966 18.3334 8.44966 18.1667 8.783 18.0834C9.19966 17.9167 9.61633 17.75 10.283 17.75C11.033 17.75 11.3663 17.9167 11.783 18.0834C12.1163 18.25 12.3663 18.3334 12.8663 18.3334C14.033 18.3334 14.8663 17.0834 15.533 16.1667Z`,
    },
  ].map((d) => ({
    stroke: 'currentColor',
    'stroke-width': '1.5',
    'stroke-miterlimit': '10',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    ...d,
  })),
};

const CustomGoogle2: CustomizeIconType = {
  name: 'custom-google-2',
  width: 21,
  height: 20,
  paths: [
    {
      d: `M18.1779 8.50002H10.3446V11.5834H14.9279C14.8446 12.3334 14.3446 13.5 13.2612 14.25C12.5946 14.75 11.5946 15.0834 10.3446 15.0834C8.1779 15.0834 6.26123 13.6667 5.59456 11.5834C5.4279 11.0834 5.34456 10.5 5.34456 9.91669C5.34456 9.33335 5.4279 8.75002 5.59456 8.25002C5.6779 8.08335 5.6779 7.91669 5.76123 7.83335C6.51123 6.08335 8.26123 4.83335 10.3446 4.83335C11.9279 4.83335 12.9279 5.50002 13.5946 6.08335L15.9279 3.75002C14.5112 2.50002 12.5946 1.66669 10.3446 1.66669C7.09456 1.66669 4.26123 3.50002 2.9279 6.25002C2.34456 7.41669 2.01123 8.66669 2.01123 10C2.01123 11.3334 2.34456 12.5834 2.9279 13.75C4.26123 16.5 7.09456 18.3334 10.3446 18.3334C12.5946 18.3334 14.5112 17.5834 15.8446 16.3334C17.4279 14.9167 18.3446 12.75 18.3446 10.1667C18.3446 9.50002 18.2612 9.00002 18.1779 8.50002Z`,
    },
  ].map((d) => ({
    stroke: 'currentColor',
    'stroke-width': '1.5',
    'stroke-miterlimit': '10',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    ...d,
  })),
};

const CustomCircleCheck2: CustomizeIconType = {
  name: 'custom-circle-check-2',
  width: 14,
  height: 15,
  paths: [
    {
      d: `M9.49703 5.87797C9.53771 5.9186 9.56998 5.96685 9.592 6.01996C9.61401 6.07308 9.62535 6.13001 9.62535 6.1875C9.62535 6.24499 9.61401 6.30192 9.592 6.35504C9.56998 6.40815 9.53771 6.4564 9.49703 6.49703L6.43453 9.55953C6.3939 9.60021 6.34565 9.63248 6.29254 9.6545C6.23943 9.67651 6.1825 9.68784 6.125 9.68784C6.06751 9.68784 6.01058 9.67651 5.95747 9.6545C5.90435 9.63248 5.8561 9.60021 5.81547 9.55953L4.50297 8.24703C4.42088 8.16494 4.37476 8.0536 4.37476 7.9375C4.37476 7.8214 4.42088 7.71006 4.50297 7.62797C4.58506 7.54588 4.69641 7.49976 4.8125 7.49976C4.9286 7.49976 5.03994 7.54588 5.12203 7.62797L6.125 8.63148L8.87797 5.87797C8.9186 5.83729 8.96685 5.80502 9.01997 5.78301C9.07308 5.76099 9.13001 5.74966 9.1875 5.74966C9.245 5.74966 9.30193 5.76099 9.35504 5.78301C9.40815 5.80502 9.4564 5.83729 9.49703 5.87797ZM12.6875 7.5C12.6875 8.62488 12.3539 9.7245 11.729 10.6598C11.104 11.5951 10.2158 12.3241 9.17651 12.7546C8.13726 13.185 6.99369 13.2977 5.89043 13.0782C4.78716 12.8588 3.77374 12.3171 2.97833 11.5217C2.18292 10.7263 1.64124 9.71284 1.42179 8.60958C1.20233 7.50631 1.31496 6.36274 1.74544 5.32349C2.17591 4.28423 2.90489 3.39597 3.8402 2.77102C4.7755 2.14607 5.87512 1.8125 7 1.8125C8.50793 1.81409 9.95365 2.41382 11.0199 3.48009C12.0862 4.54636 12.6859 5.99207 12.6875 7.5ZM11.8125 7.5C11.8125 6.54818 11.5303 5.61773 11.0014 4.82632C10.4726 4.03491 9.72104 3.41808 8.84167 3.05383C7.9623 2.68958 6.99466 2.59428 6.06113 2.77997C5.1276 2.96566 4.27009 3.42401 3.59705 4.09705C2.92401 4.77009 2.46566 5.62759 2.27997 6.56113C2.09428 7.49466 2.18959 8.4623 2.55383 9.34166C2.91808 10.221 3.53491 10.9726 4.32632 11.5014C5.11773 12.0303 6.04818 12.3125 7 12.3125C8.27591 12.3111 9.49915 11.8036 10.4014 10.9014C11.3036 9.99915 11.8111 8.77591 11.8125 7.5Z`,
    },
  ].map((d) => ({
    stroke: 'currentColor',
    'stroke-miterlimit': '10',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    ...d,
  })),
};

const CustomCircleTopRight2: CustomizeIconType = {
  name: 'custom-circle-top-right-2',
  width: 20,
  height: 21,
  paths: [
    {
      d: `M10.0003 18.8333C14.6027 18.8333 18.3337 15.1023 18.3337 10.5C18.3337 5.89759 14.6027 2.16663 10.0003 2.16663C5.39795 2.16663 1.66699 5.89759 1.66699 10.5C1.66699 15.1023 5.39795 18.8333 10.0003 18.8333Z" stroke="url(#paint0_linear_2897_3343)`,
    },
    {
      d: `M7.9375 12.5624L11.473 9.02684`,
    },
    {
      d: `M12.0619 11.9733V8.43774H8.52637`,
    },
  ].map((d) => ({
    stroke: 'currentColor',
    'stroke-miterlimit': '10',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    ...d,
  })),
};

const CustomCreditCard2: CustomizeIconType = {
  name: 'custom-credit-card-2',
  width: 14,
  height: 15,
  paths: [
    {
      d: `M1.16699 6.33337H12.8337`,
    },
    {
      d: `M6.73682 12.4582H3.756C1.68516 12.4582 1.16016 11.9449 1.16016 9.89737V5.10237C1.16016 3.24737 1.59184 2.65237 3.21934 2.55903C3.38267 2.5532 3.5635 2.54736 3.756 2.54736H10.2368C12.3077 2.54736 12.8327 3.0607 12.8327 5.1082V7.6807`,
    },
    {
      d: `M3.5 9.83337H5.83333`,
    },
    {
      d: `M12.8337 11C12.8337 11.4375 12.7111 11.8516 12.4953 12.2016C12.0928 12.8783 11.352 13.3333 10.5003 13.3333C9.64866 13.3333 8.90784 12.8783 8.50534 12.2016C8.2895 11.8516 8.16699 11.4375 8.16699 11C8.16699 9.71079 9.21116 8.66663 10.5003 8.66663C11.7895 8.66663 12.8337 9.71079 12.8337 11Z`,
    },
    {
      d: `M9.59082 10.9998L10.1683 11.5773L11.4108 10.4281`,
    },
  ].map((d) => ({
    stroke: 'currentColor',
    'stroke-miterlimit': '10',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    fill: 'none',
    ...d,
  })),
};

const CustomCash2: CustomizeIconType = {
  name: 'custom-cash-2',
  width: 14,
  height: 15,
  paths: [
    {
      d: `M7.58301 5.75H4.08301`,
    },
    {
      d: `M12.8338 6.89918V8.10088C12.8338 8.42171 12.5771 8.68419 12.2504 8.69585H11.1071C10.4771 8.69585 9.89962 8.23502 9.84712 7.60502C9.81212 7.23752 9.95211 6.89335 10.1971 6.65419C10.4129 6.43252 10.7104 6.3042 11.0371 6.3042H12.2504C12.5771 6.31587 12.8338 6.57834 12.8338 6.89918Z`,
    },
    {
      d: `M10.197 6.65412C9.95198 6.89329 9.81199 7.23745 9.84699 7.60495C9.89949 8.23495 10.477 8.69579 11.107 8.69579H12.2503V9.54163C12.2503 11.2916 11.0837 12.4583 9.33366 12.4583H4.08366C2.33366 12.4583 1.16699 11.2916 1.16699 9.54163V5.45829C1.16699 3.87163 2.12366 2.76329 3.61116 2.57662C3.76283 2.55329 3.92033 2.54163 4.08366 2.54163H9.33366C9.48533 2.54163 9.63116 2.54745 9.77116 2.57079C11.2762 2.74579 12.2503 3.85996 12.2503 5.45829V6.30413H11.037C10.7103 6.30413 10.4128 6.43245 10.197 6.65412Z`,
    },
  ].map((d) => ({
    stroke: 'currentColor',
    'stroke-miterlimit': '10',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    fill: 'none',
    ...d,
  })),
};

const CustomQrCode2: CustomizeIconType = {
  name: 'custom-qr-code-2',
  width: 14,
  height: 15,
  paths: [
    {
      d: `M1.16699 5.74996V4.29163C1.16699 2.83913 2.33949 1.66663 3.79199 1.66663H5.25033`,
    },
    {
      d: `M8.75 1.66663H10.2083C11.6608 1.66663 12.8333 2.83913 12.8333 4.29163V5.74996`,
    },
    {
      d: `M12.833 9.83337V10.7084C12.833 12.1609 11.6605 13.3334 10.208 13.3334H9.33301`,
    },
    {
      d: `M5.25033 13.3333H3.79199C2.33949 13.3333 1.16699 12.1608 1.16699 10.7083V9.25`,
    },
    {
      d: `M9.91634 6.04163V8.95829C9.91634 10.125 9.33301 10.7083 8.16634 10.7083H5.83301C4.66634 10.7083 4.08301 10.125 4.08301 8.95829V6.04163C4.08301 4.87496 4.66634 4.29163 5.83301 4.29163H8.16634C9.33301 4.29163 9.91634 4.87496 9.91634 6.04163Z`,
    },
    {
      d: `M11.0837 7.5H2.91699`,
    },
  ].map((d) => ({
    stroke: 'currentColor',
    'stroke-miterlimit': '10',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    fill: 'none',
    ...d,
  })),
};

const CustomEye2: CustomizeIconType = {
  name: 'custom-eye-2',
  width: 21,
  height: 20,
  paths: [
    {
      d: `M13.8387 10.0001C13.8387 11.6501 12.5054 12.9834 10.8554 12.9834C9.2054 12.9834 7.87207 11.6501 7.87207 10.0001C7.87207 8.35006 9.2054 7.01672 10.8554 7.01672C12.5054 7.01672 13.8387 8.35006 13.8387 10.0001Z`,
    },
    {
      d: `M10.8553 16.8916C13.797 16.8916 16.5387 15.1583 18.447 12.1583C19.197 10.9833 19.197 9.00831 18.447 7.83331C16.5387 4.83331 13.797 3.09998 10.8553 3.09998C7.91367 3.09998 5.17201 4.83331 3.26367 7.83331C2.51367 9.00831 2.51367 10.9833 3.26367 12.1583C5.17201 15.1583 7.91367 16.8916 10.8553 16.8916Z`,
    },
  ].map((d) => ({
    stroke: 'currentColor',
    'stroke-miterlimit': '10',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    fill: 'none',
    ...d,
  })),
};

const CustomEyeSlash2: CustomizeIconType = {
  name: 'custom-eye-slash-2',
  width: 21,
  height: 20,
  paths: [
    {
      d: `M12.9637 7.89172L8.74707 12.1084C8.2054 11.5667 7.87207 10.8251 7.87207 10.0001C7.87207 8.35006 9.2054 7.01672 10.8554 7.01672C11.6804 7.01672 12.4221 7.35006 12.9637 7.89172Z`,
    },
    {
      d: `M15.7053 4.80828C14.247 3.70828 12.5803 3.10828 10.8553 3.10828C7.91367 3.10828 5.17201 4.84161 3.26367 7.84161C2.51367 9.01661 2.51367 10.9916 3.26367 12.1666C3.92201 13.1999 4.68867 14.0916 5.522 14.8083`,
    },
    {
      d: `M7.87207 16.2749C8.82207 16.6749 9.8304 16.8916 10.8554 16.8916C13.7971 16.8916 16.5387 15.1583 18.4471 12.1583C19.1971 10.9833 19.1971 9.00828 18.4471 7.83328C18.1721 7.39994 17.8721 6.99161 17.5637 6.60828`,
    },
    {
      d: `M13.7807 10.5834C13.564 11.7584 12.6057 12.7167 11.4307 12.9334`,
    },
    {
      d: `M8.74746 12.1083L2.52246 18.3333`,
    },
    {
      d: `M19.1889 1.66663L12.9639 7.89163`,
    },
  ].map((d) => ({
    stroke: 'currentColor',
    'stroke-miterlimit': '10',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    fill: 'none',
    ...d,
  })),
};

const CustomSaucepan2: CustomizeIconType = {
  name: 'custom-saucepan-2',
  width: 20,
  height: 21,
  paths: [
    {
      d: `M1.66699 10.5H18.3337`,
    },
    {
      d: `M16.6663 10.5V17.1667C16.6663 17.6087 16.4907 18.0326 16.1782 18.3452C15.8656 18.6577 15.4417 18.8333 14.9997 18.8333H4.99967C4.55765 18.8333 4.13372 18.6577 3.82116 18.3452C3.5086 18.0326 3.33301 17.6087 3.33301 17.1667V10.5`,
    },
    {
      d: `M3.33301 7.16665L16.6663 3.83331`,
    },
    {
      d: `M7.38297 6.14997L7.00797 4.64164C6.95424 4.42933 6.94288 4.20852 6.97454 3.99182C7.00619 3.77512 7.08025 3.56679 7.19247 3.37872C7.30469 3.19066 7.45287 3.02656 7.62855 2.89579C7.80422 2.76503 8.00394 2.67017 8.2163 2.61664L9.83297 2.21664C10.0458 2.16305 10.2672 2.15203 10.4843 2.18422C10.7015 2.21641 10.9101 2.29118 11.0983 2.40423C11.2864 2.51728 11.4504 2.66639 11.5808 2.84299C11.7111 3.01959 11.8053 3.2202 11.858 3.43331L12.233 4.93331`,
    },
  ].map((d) => ({
    stroke: 'currentColor',
    'stroke-miterlimit': '10',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    fill: 'none',
    ...d,
  })),
};

const CustomTextLogo2: CustomizeIconType = {
  name: 'custom-text-logo-2',
  width: 168,
  height: 40,
  paths: [
    {
      d: `M47.8984 19.596C47.8984 15.6591 50.2592 13.6259 53.7637 13.6259C57.2682 13.6259 59.6289 15.6308 59.6289 19.596V25.7318H57.3455V19.596C57.3455 17.0414 55.925 15.7278 53.7637 15.7278C51.6024 15.7278 50.1819 17.0414 50.1819 19.596V25.7318H47.8984V19.596Z`,
    },
    {
      d: `M61.2656 19.8345C61.3145 16.3381 64.2084 13.5491 67.7292 13.5976C71.1767 13.6461 73.9608 16.4109 74.0096 19.8345V20.6712H63.6752C63.9276 22.6396 65.6737 24.0705 67.6681 23.9412C68.9666 24.0624 70.2283 23.4885 70.9854 22.4375H73.509C71.9582 25.6186 68.1037 26.9444 64.9004 25.4044C62.7391 24.3656 61.3389 22.2152 61.2697 19.8304M71.6082 18.638C71.1848 16.8434 69.5242 15.6146 67.6722 15.7237C65.8202 15.6065 64.1596 16.8393 63.7526 18.638H71.6082Z`,
    },
    {
      d: `M78.861 19.7375L74.3593 13.9372H77.1718L80.5623 18.5451L83.9529 13.9372H86.6962L82.1742 19.7375L86.8875 25.7319H84.0709L80.4891 20.9097L76.9073 25.7319H74.168L78.861 19.7375Z`,
    },
    {
      d: `M88.2103 21.2654V9.75769H90.4937V13.9331H97.0346V16.0107H90.4937V21.2654C90.4937 23.1287 91.4787 23.9412 92.9684 23.9412C94.4581 23.9412 95.4676 23.1611 95.4676 21.2654V21.0067H97.7266V21.2654C97.7266 23.8765 95.5978 25.9946 92.9684 25.9986C90.339 25.9986 88.2062 23.8846 88.2021 21.2735V21.2654`,
    },
    {
      d: `M105.062 19.8345C105.135 16.3422 108.041 13.5653 111.562 13.634C114.981 13.7027 117.736 16.4392 117.806 19.8345V20.6712H107.467C107.719 22.6397 109.466 24.0705 111.46 23.9412C112.758 24.0625 114.02 23.4885 114.777 22.4376H117.301C115.75 25.6186 111.895 26.9444 108.692 25.4044C106.531 24.3656 105.131 22.2152 105.062 19.8304M115.404 18.638C114.981 16.8434 113.32 15.6146 111.468 15.7237C109.616 15.6065 107.955 16.8393 107.548 18.638H115.404Z`,
    },
    {
      d: `M126.027 18.1611H119.727V20.3357H126.027V18.1611Z`,
    },
    {
      d: `M127.517 19.9315C127.326 16.6372 129.861 13.8159 133.175 13.6299C133.394 13.6178 133.618 13.6178 133.838 13.6299C137.2 13.4521 140.074 16.0107 140.253 19.3494C140.261 19.5354 140.265 19.7213 140.257 19.9072C140.399 23.153 137.868 25.8975 134.603 26.039C134.477 26.043 134.347 26.0471 134.221 26.043C132.414 26.1198 130.716 25.2023 129.796 23.6542V30.7682H127.513V19.9274L127.517 19.9315ZM137.953 19.8345C137.953 17.5992 136.13 15.7884 133.879 15.7884C131.628 15.7884 129.804 17.5992 129.804 19.8345C129.804 22.0697 131.628 23.8806 133.879 23.8806C136.13 23.8806 137.953 22.0697 137.953 19.8345Z`,
    },
    {
      d: `M141.413 19.9315C141.283 16.5807 143.912 13.7553 147.286 13.626C147.469 13.6179 147.653 13.6219 147.832 13.626C151.157 13.4562 153.986 15.9986 154.157 19.2969C154.169 19.5071 154.169 19.7173 154.157 19.9275V25.7319H152.065V23.153C151.295 24.9881 149.448 26.1441 147.449 26.0431C144.185 26.1118 141.478 23.5411 141.409 20.2953C141.409 20.1741 141.409 20.0528 141.409 19.9275M151.894 19.8345C151.894 17.5912 150.066 15.7723 147.811 15.7723C145.552 15.7723 143.721 17.5871 143.721 19.8264V19.8345C143.721 22.0779 145.548 23.8968 147.803 23.8968C150.062 23.8968 151.894 22.0819 151.894 19.8426V19.8345Z`,
    },
    {
      d: `M156.367 27.1384H158.65C159.237 28.4723 160.633 29.2646 162.09 29.0948C164.3 29.0948 165.721 28.0439 165.721 25.368V23.6744C164.959 25.1336 163.409 26.0228 161.756 25.942C158.797 25.942 156.273 24.1029 156.273 19.9719V13.9331H158.557V19.976C158.557 22.5305 159.973 23.8199 162.139 23.8199C164.039 23.9089 165.651 22.4537 165.745 20.5661C165.753 20.368 165.745 20.17 165.721 19.976V13.9331H168.004V25.3236C168.004 29.4303 165.379 31.0754 162.09 31.0754C159.346 31.0754 157.063 29.8102 156.367 27.1384Z`,
    },
    {
      d: `M40.0834 5.19022V25.0811C40.0834 23.8604 29.6514 12.2234 29.6514 12.2234V4.79814C29.8752 1.94042 32.3866 -0.193772 35.2643 0.0285396C37.9791 0.238726 40.0753 2.4861 40.0834 5.19022Z`,
    },
    {
      d: `M40.0923 25.0851C40.0923 27.9509 37.7519 30.2751 34.8661 30.2751C33.5229 30.2751 32.2326 29.7618 31.2598 28.8402L30.9342 28.5047L29.6602 27.187L12.1621 9.04632L11.6289 8.49256L11.6208 8.48448C9.78511 6.27348 10.1026 3.00348 12.3331 1.18052C14.3234 -0.448423 17.2133 -0.391834 19.1386 1.31795C19.1386 1.32603 19.1508 1.33007 19.1508 1.33007C19.1508 1.33007 19.163 1.3422 19.1671 1.34624L19.6758 1.87575C19.6758 1.87575 19.684 1.88383 19.6881 1.88787L29.6643 12.2193L38.2891 21.1563L38.9445 21.8353C39.6852 22.7529 40.0882 23.8927 40.0882 25.069`,
    },
    {
      d: `M0.0078125 34.8062V14.9153C0.0078125 16.136 10.4399 27.7731 10.4399 27.7731V35.2023C10.216 38.06 7.70467 40.1942 4.827 39.9719C2.10807 39.7617 0.0118828 37.5144 0.0078125 34.8103`,
    },
    {
      d: `M0 14.9154C0 12.0496 2.34447 9.72942 5.23029 9.73346C6.57347 9.73346 7.85967 10.2468 8.83247 11.1684L9.15809 11.5039L10.4321 12.8216L27.9342 30.9501L28.4674 31.5039L28.4755 31.512C30.3112 33.723 29.9937 36.993 27.7632 38.8159C25.7729 40.4449 22.883 40.3883 20.9578 38.6785C20.9578 38.6785 20.9456 38.6704 20.9456 38.6664C20.9456 38.6623 20.9333 38.6542 20.9293 38.6502L20.4205 38.1207C20.4205 38.1207 20.4124 38.1126 20.4083 38.1086L10.4321 27.7771L1.8072 18.8402L1.15188 18.1611C0.407026 17.2395 0 16.0956 0 14.9154Z`,
    },
  ].map((d) => ({
    stroke: 'none',
    'stroke-miterlimit': '10',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    fill: 'currentColor',
    ...d,
  })),
};

const CustomeInfoCircle: CustomizeIconType = {
  name: 'custom-info-circle',
  width: 14,
  height: 14,
  paths: [
    {
      d: `M7.00002 12.8333C10.2084 12.8333 12.8334 10.2083 12.8334 6.99996C12.8334 3.79163 10.2084 1.16663 7.00002 1.16663C3.79169 1.16663 1.16669 3.79163 1.16669 6.99996C1.16669 10.2083 3.79169 12.8333 7.00002 12.8333Z`,
    },
    {
      d: `M7 4.66663V7.58329`,
    },
    {
      d: `M6.99683 9.33337H7.00207`,
    },
  ].map((d) => ({
    stroke: 'currentColor',
    'stroke-miterlimit': '10',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    fill: 'none',
    ...d,
  })),
};

const CustomTickCircle: CustomizeIconType = {
  name: 'custom-tick-circle',
  width: 14,
  height: 14,
  paths: [
    {
      d: `M7.00008 12.8334C10.2084 12.8334 12.8334 10.2084 12.8334 7.00008C12.8334 3.79175 10.2084 1.16675 7.00008 1.16675C3.79175 1.16675 1.16675 3.79175 1.16675 7.00008C1.16675 10.2084 3.79175 12.8334 7.00008 12.8334Z`,
    },
    {
      d: `M4.52075 6.99995L6.17159 8.65079L9.47909 5.34912`,
    },
  ].map((d, i) => ({
    stroke: 'currentColor',
    'stroke-miterlimit': '10',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-dasharray': i == 0 ? '2 2' : undefined,
    fill: 'none',
    ...d,
  })),
};
